import { HttpClient } from '@angular/common/http';
import { API_CONSTANT } from './../../services/api.constant';
import { HttpClientService } from './../../services/http-client.service';
import { Injectable } from '@angular/core';

@Injectable()
export class DownloadService {
  constructor(private http: HttpClientService, private httpLocal: HttpClient) {}

  getDocumentRequestList(params?) {
    return this.http.get(API_CONSTANT.documents_download, params);
  }

  deleteDocumentRequest(id) {
    return this.http.delete(API_CONSTANT.documents_download + id + '/');
  }

  createDocumentRequest(data) {
    return this.httpLocal.post(API_CONSTANT.create_document_request, data);
  }

  updateDocumentRequest(data) {
    return this.http.patch(API_CONSTANT.patch_document_request, data);
  }

  // createDocumentRequest(data) {
  //   return this.httpLocal.post(API_CONSTANT.documents_download, data);
  // }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/download/download.service.ts